import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() src: any;
  @Input() item: any;
  @Input() type: any;

  audio: any = null;
  audioLoaded:boolean = false;
  protected intervalLoadTimer:any = null;
  audioProgress:any = 0;
  constructor() { }
  
  ngOnInit() {
    if(this.type == 'mp3') {
      this.audio = new Audio(this.src);
      this.audio.play();
      this.intervalLoadTimer = setInterval(()=>{ 
        if(this.audio.currentTime > 0) {
          this.audio.pause();
          this.audioLoaded = true;
          clearInterval(this.intervalLoadTimer); 
          this.addEventListeners();
        }
      },10);
    }
  }

  ngOnChanges() {
    
  }

  ngOnDestroy() {
    this.audio.src = "";
  }

  audioPlayToggle(e:Event){
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    if(this.audio.paused) this.audio.play();
    else this.audio.pause();
  }
  addEventListeners() {
    
    this.audio.ontimeupdate = ()=>{ this.audioProgress = 100*(this.audio.currentTime/this.audio.duration); }
  }
  wasPlaying:boolean=false;
  onSeekEnd() { if(this.wasPlaying) {this.audio.play();this.wasPlaying=false;} }
  onSeek(e:any){
    if(!this.audio.paused) {
      this.audio.pause();
      this.wasPlaying = true;
      this.audio.currentTime = (e.value*this.audio.duration)/100;
    } else this.audio.currentTime = (e.value*this.audio.duration)/100;
  }
 
}



// WEBPACK FOOTER //
// ./public/app/common/audio-player/audio-player.component.ts